import { WaitingResults } from '../../components/waiting-results';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router';
import { useNavigate } from '@repo/poly-hooks/routing';
import { FullscreenBase } from '@repo/design-system-kit/components/fullscreen/base/fullscreen-base';
import { useHomePage } from '@repo/shared-kit/home-page/home-page';
import { isExternalUrl } from '@repo/runtime-kit/utils/is-external-url';
import styles from './waiting-results.module.css';

export function KycWaitingResultsRoute() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const homePage = useHomePage();

  const provider = searchParams.get('provider');
  const redirectUrl = searchParams.get('redirectRoute') ?? homePage.defaultRouteAbsolutePath;
  const trackingEventOrigin = searchParams.get('trackingEventOrigin');

  const handleClose = useCallback(() => {
    if (isExternalUrl(redirectUrl)) {
      window.location.href = redirectUrl;
      return;
    }

    navigate(redirectUrl);
  }, [navigate, redirectUrl]);

  return (
    <FullscreenBase onClose={handleClose}>
      <div className={styles.container}>
        <WaitingResults
          provider={provider ?? undefined}
          redirectUrl={redirectUrl}
          origin={trackingEventOrigin}
        />
      </div>
    </FullscreenBase>
  );
}
